import React, { Component } from 'react'
import { connect } from 'react-redux'
import { req_list_eps_links, req_sort_eps_links, req_delete_eps_links } from '../../api'
import { Card, Table, Button, Modal, message } from 'antd'
import { MenuOutlined, PlusOutlined } from '@ant-design/icons'

import { sortableContainer, sortableElement, sortableHandle } from 'react-sortable-hoc'
import { arrayMoveImmutable } from 'array-move'

import LinksAddModal from './Introduction-link-add-modal'

import './introduction-link.css'

const SortableItem = sortableElement(props => <tr {...props} />);
const SortableContainer = sortableContainer(props => <tbody {...props} />);
const DragHandle = sortableHandle(() => <MenuOutlined style={{ cursor: 'grab', color: '#999' }} />);

class IntroductionLink extends Component {
    // 基礎通用參數 //////////////////////////////////////////////    
    state = {
        dataSource: [],
        isAddModal: false
    };

    UNSAFE_componentWillMount() {
        this.init_columns()
    }


    componentDidMount() {
        this.api_list_items()
    }

    // 遠端數據處理 //////////////////////////////////////////////

    api_list_items = async () => {
        const { token, userCode } = this.props.user
        this.setState({ loading: true })
        const result = await req_list_eps_links(userCode, token)
        this.setState({ loading: false })

        if (result.total > 0) {
            const dataSource = result.data
            this.setState({ dataSource })
        }
    }

    api_sort_item = async (items) => {
        const { token } = this.props.user
        await req_sort_eps_links(items, token)
    }

    api_delete_item = async (key) => {
        const { token } = this.props.user
        const result = await req_delete_eps_links(key, token)
        if (result.status === 'success') {
            message.success('刪除成功')
            this.api_list_items(this.current)
        } else {
            //console.log(result)
        }
    }

    // 數據配置設定 ////////////////////////////////////////////// 

    init_columns = () => {
        this.columns = [
            {
                title: '排序',
                dataIndex: 'sort',

                className: 'drag-visible',
                render: () => <>
                    <div className='text-center'>
                        <DragHandle />
                    </div>
                </>,
            },
            {
                title: '名稱',
                dataIndex: 'LinkDescription',
                className: 'drag-visible',
                render: (field) => {
                    return (
                        <div>
                            <span style={{ fontSize: '1.3em' }}> {field}</span>
                        </div>
                    )
                },
            },
            {
                title: '網址',
                dataIndex: 'LinkUrl',
                render: (field) => {
                    return (
                        <div>
                            <span style={{ fontSize: '1.3em' }}> {field}</span>
                        </div>
                    )
                },
            }, {
                title: '操作',
                render: (item) => {
                    const { Uid } = item
                    return (
                        <>
                            <Button type='dashed' style={{ color: 'DarkBlack' }} onClick={() => this.handle_show_ui_modal('delete', Uid)}> 刪除</Button>
                        </>
                    )
                }
            },
        ];
    }

    // 操作互動處理 //////////////////////////////////////////////

    onSortEnd = ({ oldIndex, newIndex }) => {
        const { dataSource } = this.state;
        if (oldIndex !== newIndex) {
            const newData = arrayMoveImmutable([].concat(dataSource), oldIndex, newIndex).filter(el => !!el);
            //console.log('Sorted items: ', newData);
            const arr = newData.map((obj, index) => ({
                Uid: obj.Uid,
                ItemSortNum: index
            }));
            //console.log('arr: ', arr);
            this.setState({ dataSource: newData });
            this.api_sort_item(arr)
        }
    }

    DraggableContainer = props => (
        <SortableContainer
            useDragHandle
            disableAutoscroll
            helperClass="row-dragging"
            onSortEnd={this.onSortEnd}
            {...props}
        />
    )

    DraggableBodyRow = ({ className, style, ...restProps }) => {
        const { dataSource } = this.state;
        // function findIndex base on Table rowKey props and should always be a right array index
        const index = dataSource.findIndex(x => x.ItemSortNum === restProps['data-row-key']);
        return <SortableItem index={index} {...restProps} />;
    }

    handle_show_ui_modal = (modal, item) => {
        switch (modal) {
            case 'add':
                this.setState({ isAddModal: true })
                break;
            case 'delete':
                Modal.confirm({
                    title: `您確定刪除此筆資訊`,
                    onOk: () => {
                        this.api_delete_item(item)
                    }
                })
                break;
            case 'download':

                break;
            default:
        }
    }

    handle_data_refresh = () => {
        this.api_list_items()
    }
    /////////////////////////////////////////////////////////////     
    render() {
        const { dataSource, isAddModal } = this.state;
        const title = (
            <>
                <Button type='primary' icon={<PlusOutlined />} onClick={() => this.handle_show_ui_modal('add')}>增加</Button>
            </>
        )
        return (
            <Card title={title}>
                <Table
                    pagination={false}
                    dataSource={dataSource}
                    columns={this.columns}
                    rowKey="ItemSortNum"
                    components={{
                        body: {
                            wrapper: this.DraggableContainer,
                            row: this.DraggableBodyRow,
                        },
                    }}
                />
                <Modal
                    destroyOnClose={true}
                    visible={isAddModal}
                    width={500}
                    onOk={() => {
                        this.setState({ isAddModal: false })
                        this.handle_data_refresh()
                    }}
                    onCancel={() => {
                        this.setState({ isAddModal: false })
                    }}
                    cancelButtonProps={{ style: { display: 'none' } }}
                >
                    <LinksAddModal />
                </Modal>
            </Card>
        )
    }

}

export default connect(
    state => ({ user: state.user }),
    {}
)(IntroductionLink)